import React, { createContext, useContext, useState } from "react";

const MobileModeContext = createContext();

export const MobileModeProvider = ({ children }) => {
  const [mobileMode, setMobileMode] = useState("info");
  return (
    <MobileModeContext.Provider value={{ mobileMode, setMobileMode }}>
      {children}
    </MobileModeContext.Provider>
  );
};

export const useMobileMode = () => useContext(MobileModeContext);
